import {auth} from '@/api/firebase';
import {Logger} from '@vanti/vue-logger';

const log = Logger.get('auth');
const APP_NAME = 'room-booking';

export default {
  namespaced: true,
  state: {
    authUser: {},
    authUserToken: {},
    authUserNotified: false
  },
  getters: {
    authUser(state) {
      return state.authUser;
    },
    authUserUid(state, getters) {
      return getters.authUser ? getters.authUser.uid : null;
    },
    authUserClaims(state) {
      return state.authUserToken.claims || {};
    },
    authLoaded(state) {
      return state.authUserNotified;
    },
    hasAppAccess(state, getters) {
      const roles = getters.userRoles;
      return roles.includes('ns.admin') || roles.some(r => r.startsWith(APP_NAME + '.'));
    },
    userRoles(state, getters) {
      const claims = getters.authUserClaims;
      if (!claims.hasOwnProperty('van')) {
        return [];
      }
      if (claims.van.hasOwnProperty('r')) {
        return claims.van.r;
      }
      return [];
    },
    isAdmin(state, getters) {
      const roles = getters.userRoles;
      return roles.includes('ns.admin') || roles.includes(APP_NAME + '.admin');
    },
    isAuthenticated(state) {
      return Object.keys(state.authUser).length !== 0;
    },
    ns(state) {
      if (state.authUserToken && state.authUserToken.claims && state.authUserToken.claims.van) {
        return state.authUserToken.claims.van.ns;
      }
      return '-';
    }
  },
  mutations: {
    updateAuthUser(state, authUser) {
      state.authUser = authUser ? authUser : {};
    },
    setAuthUser(state, authUser) {
      state.authUser = authUser ? authUser : {};
      state.authUserToken = {};
    },
    setAuthUserToken(state, token) {
      state.authUserToken = token;
    },
    setAuthUserNotified(state) {
      state.authUserNotified = true;
    }
  },
  actions: {
    init: {
      root: true,
      handler({dispatch}) {
        return dispatch('bindAuthUser');
      }
    },
    bindAuthUser({commit}) {
      log.info('bindAuthUser');
      auth.then(auth => auth.onAuthStateChanged(user => {
        log.info('onAuthStateChanged', user);
        // only store the properties we use, this may help with Vue dev tools issues
        commit('setAuthUser', user === null ? {} : {
          email: user.email,
          uid: user.uid,
          displayName: user.displayName
        });
        commit('setAuthUserNotified');
        if (user) {
          user.getIdTokenResult()
              .then(r => commit('setAuthUserToken', r))
              .catch(err => log.error('error getting user token', err));
        } else {
          commit('setAuthUser', {});
          commit('setAuthUserToken', {});
        }
      }, err => {
        log.error('onAuthStateChanged', err);
      }, () => {
        log.info('onAuthStateChanged completed');
      }));
    },
    signIn(state, {email, password}) {
      return auth.then(auth => auth.signInWithEmailAndPassword(email, password));
    },
    signOut() {
      log.log('signing out');
      return auth.then(auth => auth.signOut());
    },
    updateProfile({commit}, profile) {
      return auth.then(auth => auth.currentUser.updateProfile(profile))
          .then(() => commit('updateAuthUser', auth.currentUser));
    }
  }
};
